import React, { useCallback, useState } from 'react'
import { Badge } from 'antd'
import {
  CalculatorOutlined,
  CalendarOutlined,
  MessageOutlined,
  UnorderedListOutlined,
} from '@ant-design/icons'
import styled from 'styled-components'
import { useNavigate, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { createSelector } from 'reselect'
import Ntf from './ntf'

const createViewed = createSelector(
  (state: any) => state.viewed,
  tasks => tasks
)

const NavigationButtons = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;

  @media (max-width: 768px) {
    gap: 8px;
  }
`

const NavigationButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: color 0.3s;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  width: 40px;
  height: 40px;

  &:hover {
    color: #8b9ca7;
  }
  
  svg {
    width: 16px;
  }

  @media (max-width: 768px) {
    width: 48px;
  }
`

const NavigationButtonIcon = styled.span`
  font-size: 20px;

  @media (max-width: 768px) {
    font-size: 18px;
  }
`

const NavigationButtonTitle = styled.span`
  font-size: 10px;
  line-height: 16px;

  @media (max-width: 768px) {
    font-size: 9px;
  }
`

export const TopMenu = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const viewed = useSelector(createViewed)
  const [isOpen, setOpen] = useState<boolean>(false)

  const isCalendarPage = location.pathname === '/tasks/calendar'

  const handleChatClick = useCallback(() => {
    setOpen(true)
  }, [])

  const handleNewCalendarClick = useCallback(() => {
    navigate(isCalendarPage ? '/tasks' : '/tasks/calendar')
  }, [navigate, isCalendarPage])

  return (
    <NavigationButtons>
      <Ntf />
      <NavigationButton onClick={handleNewCalendarClick}>
        <Badge count={viewed['tasks'] || 0} offset={[5, 5]}>
          <NavigationButtonIcon>
            {isCalendarPage ? <UnorderedListOutlined /> : <CalendarOutlined />}
          </NavigationButtonIcon>
        </Badge>
      </NavigationButton>
      <NavigationButton onClick={handleChatClick}>
        <Badge count={0} offset={[5, 5]}>
          <NavigationButtonIcon>
            <MessageOutlined />
          </NavigationButtonIcon>
        </Badge>
      </NavigationButton>
    </NavigationButtons>
  )
}